 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"addr_book":"addr_book","admin":"admin","login":"login","join":"join","pay":"pay","stats":"stats","svc_block_mdn":"svc_block_mdn","svc_hist":"svc_hist","svc_voice_scn":"svc_voice_scn","help":"help","svc_staff":"svc_staff","svc_voice_intro":"svc_voice_intro","svc_wv":"svc_wv"}[chunkId]||chunkId) + "." + {"chunk-37adb49d":"84af501b","chunk-2d4daf38":"65d746d5","chunk-2d4f877c":"e39cf4a2","chunk-4c5c8814":"67886f91","chunk-92a14dc8":"5d05d012","addr_book":"69448aaa","admin":"32ce99b4","chunk-429f4078":"8b79ea6f","chunk-4479df79":"1b09cbbe","chunk-59d5fcdc":"c79161e8","chunk-59d72a12":"8eae34e5","chunk-59d8b010":"cd944593","chunk-59fddcd4":"0415866e","chunk-59ffcfc8":"35e05591","chunk-5a009ecc":"77587b74","chunk-5a00b428":"d314c6a6","chunk-5a03d37a":"fe978d08","chunk-5a063014":"9a84f8a2","chunk-795f3954":"950efef3","chunk-d008b3a0":"9559ab79","chunk-f8799982":"4c0dad9a","chunk-1a02bce2":"e6942dea","chunk-3ec1cf92":"866b2520","chunk-8fd4faf6":"1736c454","chunk-3f004817":"4bae93f4","chunk-51939176":"3c9f01c8","chunk-6fc9a5d6":"c8b7bb5d","chunk-986f5954":"dc9f1af4","chunk-053362e7":"02f512ce","chunk-07686ed2":"552dd69c","chunk-17dcdc8c":"e2fd7d1c","chunk-207e9c0b":"c55a5c1f","chunk-3ad192b2":"54f5ce4c","chunk-44269e0b":"1c48e40f","chunk-6c2f5c1a":"451e5362","login":"24ea21ba","join":"cd6efa52","pay":"5f5aff1f","stats":"a3f4c34a","svc_block_mdn":"ab1e74e0","svc_hist":"2365d56e","svc_voice_scn":"facdbd54","chunk-2d208c29":"de83e7d1","chunk-e37c4200":"d10fa8f5","help":"08f6979f","svc_staff":"98753213","svc_voice_intro":"85f227e7","svc_wv":"ae04428b","chunk-549d2a09":"5a582e86","chunk-2d0c739f":"81224cb8","chunk-5860595a":"0341e27c","chunk-2d2306a4":"9816cf9e","chunk-52b2db8c":"0db2abf2","chunk-2d224979":"1c3cc62d","chunk-684efcf0":"4e578632","chunk-1aaa92de":"7cf857f6","chunk-914aeb54":"0bac715d","chunk-ff9c2418":"8cea500c","chunk-8c10dd2a":"fc50c969","chunk-2d0ae957":"9d533d13","chunk-2d228e64":"9c4af032","chunk-1d142e2c":"be0de59a","chunk-2d0d6e88":"a030addd","chunk-2d0ba88d":"7598fad3","chunk-2d0e6732":"106cfb13","chunk-2d216779":"5ca2e1bf","chunk-2d21a389":"d91c536c","chunk-608f933e":"6c444915","chunk-2d0d5c40":"6d15d1c1","chunk-2d21024a":"22596ff9","chunk-59fd81e8":"d88b1a89","chunk-560490ca":"37dcf198","chunk-b8cc2ab4":"3856d915","chunk-2a87bf33":"43320a40","chunk-2d0a479e":"a79171a5","chunk-2d0e4a60":"654fc46b","chunk-0cbaf47a":"3ab89bb1","chunk-6caab623":"ea181e52","chunk-48f9e93c":"ac0a9a13","chunk-5a042df0":"c21dd422","chunk-d50ba80a":"980b7846","chunk-5a01eb40":"305b7b9d","chunk-2d0e6c6b":"df7deffa","chunk-aa24b036":"2c18fbc4","chunk-59ff3466":"01ab7ab3","chunk-5a010dc2":"a7f7704d","chunk-bde02ae6":"ac1bc110","chunk-af143a52":"d0c65c56","chunk-3e792cf2":"5875bd24","chunk-09479446":"41e6ceca","chunk-e721b3fa":"b86aacd3","chunk-7115cc30":"38bec7d2","chunk-3489fdfc":"b1f981a8","chunk-8789e648":"ac889482","chunk-5852c634":"84d487cb","chunk-5a060e30":"87fa8b59","chunk-05ae75a4":"2043b65e","chunk-2d0e5d3f":"646f85bf","chunk-c566496a":"360b009e","chunk-751ff39a":"6e35c2a7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-37adb49d":1,"chunk-2d4daf38":1,"chunk-2d4f877c":1,"chunk-4c5c8814":1,"chunk-92a14dc8":1,"chunk-429f4078":1,"chunk-4479df79":1,"chunk-795f3954":1,"chunk-d008b3a0":1,"chunk-f8799982":1,"chunk-1a02bce2":1,"chunk-3ec1cf92":1,"chunk-8fd4faf6":1,"chunk-3f004817":1,"chunk-51939176":1,"chunk-6fc9a5d6":1,"chunk-986f5954":1,"chunk-053362e7":1,"chunk-07686ed2":1,"chunk-17dcdc8c":1,"chunk-207e9c0b":1,"chunk-3ad192b2":1,"chunk-44269e0b":1,"chunk-6c2f5c1a":1,"login":1,"join":1,"chunk-e37c4200":1,"chunk-549d2a09":1,"chunk-5860595a":1,"chunk-52b2db8c":1,"chunk-684efcf0":1,"chunk-1aaa92de":1,"chunk-914aeb54":1,"chunk-ff9c2418":1,"chunk-8c10dd2a":1,"chunk-1d142e2c":1,"chunk-560490ca":1,"chunk-b8cc2ab4":1,"chunk-2a87bf33":1,"chunk-0cbaf47a":1,"chunk-6caab623":1,"chunk-48f9e93c":1,"chunk-d50ba80a":1,"chunk-aa24b036":1,"chunk-bde02ae6":1,"chunk-af143a52":1,"chunk-3e792cf2":1,"chunk-09479446":1,"chunk-e721b3fa":1,"chunk-7115cc30":1,"chunk-3489fdfc":1,"chunk-8789e648":1,"chunk-5852c634":1,"chunk-05ae75a4":1,"chunk-c566496a":1,"chunk-751ff39a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"addr_book":"addr_book","admin":"admin","login":"login","join":"join","pay":"pay","stats":"stats","svc_block_mdn":"svc_block_mdn","svc_hist":"svc_hist","svc_voice_scn":"svc_voice_scn","help":"help","svc_staff":"svc_staff","svc_voice_intro":"svc_voice_intro","svc_wv":"svc_wv"}[chunkId]||chunkId) + "." + {"chunk-37adb49d":"de69aa5f","chunk-2d4daf38":"67646f75","chunk-2d4f877c":"67646f75","chunk-4c5c8814":"6cdb2d70","chunk-92a14dc8":"f0222215","addr_book":"31d6cfe0","admin":"31d6cfe0","chunk-429f4078":"41ffce47","chunk-4479df79":"df9d9a7c","chunk-59d5fcdc":"31d6cfe0","chunk-59d72a12":"31d6cfe0","chunk-59d8b010":"31d6cfe0","chunk-59fddcd4":"31d6cfe0","chunk-59ffcfc8":"31d6cfe0","chunk-5a009ecc":"31d6cfe0","chunk-5a00b428":"31d6cfe0","chunk-5a03d37a":"31d6cfe0","chunk-5a063014":"31d6cfe0","chunk-795f3954":"bd126c77","chunk-d008b3a0":"f88c158a","chunk-f8799982":"c8d11a39","chunk-1a02bce2":"dfbf66e6","chunk-3ec1cf92":"b27bcb75","chunk-8fd4faf6":"5c461524","chunk-3f004817":"30cc2890","chunk-51939176":"acc22607","chunk-6fc9a5d6":"acc22607","chunk-986f5954":"fcfb0479","chunk-053362e7":"9ba3c2da","chunk-07686ed2":"0d88be9b","chunk-17dcdc8c":"43e1bb6e","chunk-207e9c0b":"43e1bb6e","chunk-3ad192b2":"43e1bb6e","chunk-44269e0b":"e8c6873e","chunk-6c2f5c1a":"bed9b5c2","login":"f264ca4b","join":"81ea3344","pay":"31d6cfe0","stats":"31d6cfe0","svc_block_mdn":"31d6cfe0","svc_hist":"31d6cfe0","svc_voice_scn":"31d6cfe0","chunk-2d208c29":"31d6cfe0","chunk-e37c4200":"6f202bd2","help":"31d6cfe0","svc_staff":"31d6cfe0","svc_voice_intro":"31d6cfe0","svc_wv":"31d6cfe0","chunk-549d2a09":"be288919","chunk-2d0c739f":"31d6cfe0","chunk-5860595a":"726b3234","chunk-2d2306a4":"31d6cfe0","chunk-52b2db8c":"1a9ae77b","chunk-2d224979":"31d6cfe0","chunk-684efcf0":"cab59e1c","chunk-1aaa92de":"acc22607","chunk-914aeb54":"acc22607","chunk-ff9c2418":"b7da9e72","chunk-8c10dd2a":"acc22607","chunk-2d0ae957":"31d6cfe0","chunk-2d228e64":"31d6cfe0","chunk-1d142e2c":"d37a3c29","chunk-2d0d6e88":"31d6cfe0","chunk-2d0ba88d":"31d6cfe0","chunk-2d0e6732":"31d6cfe0","chunk-2d216779":"31d6cfe0","chunk-2d21a389":"31d6cfe0","chunk-608f933e":"31d6cfe0","chunk-2d0d5c40":"31d6cfe0","chunk-2d21024a":"31d6cfe0","chunk-59fd81e8":"31d6cfe0","chunk-560490ca":"f39c8aca","chunk-b8cc2ab4":"94747591","chunk-2a87bf33":"dcc009ac","chunk-2d0a479e":"31d6cfe0","chunk-2d0e4a60":"31d6cfe0","chunk-0cbaf47a":"3971fdfb","chunk-6caab623":"455f89f9","chunk-48f9e93c":"0bace561","chunk-5a042df0":"31d6cfe0","chunk-d50ba80a":"67646f75","chunk-5a01eb40":"31d6cfe0","chunk-2d0e6c6b":"31d6cfe0","chunk-aa24b036":"33ac40b1","chunk-59ff3466":"31d6cfe0","chunk-5a010dc2":"31d6cfe0","chunk-bde02ae6":"308359b6","chunk-af143a52":"33ac40b1","chunk-3e792cf2":"080d7221","chunk-09479446":"4c36f947","chunk-e721b3fa":"093f807b","chunk-7115cc30":"ea3c4e9d","chunk-3489fdfc":"dcc009ac","chunk-8789e648":"76a811a3","chunk-5852c634":"726b3234","chunk-5a060e30":"31d6cfe0","chunk-05ae75a4":"bafd9499","chunk-2d0e5d3f":"31d6cfe0","chunk-c566496a":"5c038642","chunk-751ff39a":"b3374feb"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
